import Vue, { VueConstructor } from "vue";
import OneKeyTipVue from "../components/OneKey/OneKeyTip.vue";

const onekeyInstance = new OneKeyTipVue();
Vue.use(vue => {
    const reg = (id: number, type: "一键登录" | "勾选认证") => {
        onekeyInstance.$mount();
        // @ts-ignore
        onekeyInstance.oneKey(id, type);
    }
    vue.prototype.$onekey = reg;
});

// console.log(Vue.$onekey)